<div class = "cell-real-estate-mortgages-calculator_schedule">
	<div class ="cell-real-estate-mortgages-calculator_schedule--table">
		<div class = "cell-real-estate-mortgages-calculator_schedule--table-title">
			<%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.summary') %>
		</div>

    <div class = "cell-real-estate-mortgages-calculator_schedule--table-header">
      <div class = "cell-real-estate-mortgages-calculator_schedule--table--row content-row">
        <div class = "cell-real-estate-mortgages-calculator_schedule--table--col-month heading">
          <%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.month') %>
        </div>
        <div class = "cell-real-estate-mortgages-calculator_schedule--table--col heading">
          <%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.installment') %>
        </div>
        <div class = "cell-real-estate-mortgages-calculator_schedule--table--col heading">
          <%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.principle_repayment') %>
        </div>
        <div class = "cell-real-estate-mortgages-calculator_schedule--table--col heading">
          <%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.interest_payment') %>
        </div>
        <div class = "cell-real-estate-mortgages-calculator_schedule--table--col heading">
          <%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.outstanding_payment') %>
        </div>
      </div>
    </div>

    <div class = "cell-real-estate-mortgages-calculator_schedule--table-body">
      <% for(var year in schedule) { %>
        <% for(var interval in schedule[year].monthly_schedule ) { %>
          <div class='cell-real-estate-mortgages-calculator_schedule--table--row content-row month-row'>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--col-month'>
              <%= schedule[year].monthly_schedule[interval].month %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
              <%= schedule[year].monthly_schedule[interval].pmt_value %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
              <%= schedule[year].monthly_schedule[interval].principle %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
              <%= schedule[year].monthly_schedule[interval].interest %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
              <%= schedule[year].monthly_schedule[interval].loan_balance %>
            </div>
          </div>
        <%  } %>

        <div class='cell-real-estate-mortgages-calculator_schedule--table--row content-row annual-row'>
          <div class='cell-real-estate-mortgages-calculator_schedule--table--col-month'>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--data'>
              <%= schedule[year].year %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--subtitle'>
              <%= labels.breakdown %>
            </div>
          </div>
          <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--data'>
              <%= schedule[year].ytd_pmt_value %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--subtitle'>
              <%= labels.total_installment %>
            </div>
          </div>
          <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--data'>
              <%= schedule[year].ytd_principle %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--subtitle'>
              <%= labels.total_principle %>
            </div>
          </div>
          <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--data'>
              <%= schedule[year].ytd_interest %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--subtitle'>
              <%= labels.total_interest %>
            </div>
          </div>
          <div class='cell-real-estate-mortgages-calculator_schedule--table--col'>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--data'>
              <%= schedule[year].loan_balance %>
            </div>
            <div class='cell-real-estate-mortgages-calculator_schedule--table--annual--subtitle'>
              <%= labels.outstanding %>
            </div>
          </div>
        </div>
      <% } %>
    </div>
	</div>
</div>

